import * as _ from "lodash";
export class HomePageComponent implements ng.IComponentOptions {
  public controller: any = HomeController;
  public template: string = /*html*/`
    <div class="page-header" scroll ng-class="{'page-scroll':boolChangeClass}">
    <nav class="navbar navbar-fixed-top" ng-init="isNavCollapsed=true">
    <div class="navbar-header">
    <img src="${require('../../../../images/dfms-logo.png')}" alt=""/>
    <button type="button" class="navbar-toggle" ng-click="isNavCollapsed = !isNavCollapsed" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
    </button>
    </div>
    <div class="navbar-collapse" uib-collapse="isNavCollapsed">
    <ul class="nav navbar-nav">
    <li><a href="#/search">DATASETS</a></li>
    <li><a href="#/about">ABOUT</a></li>
    <li><a href="#/login">LOGIN</a></li>
    <li><a href="#/register">REGISTER</a></li>
    </ul>
    </div>
    </nav>
    </div>




    <div class="hero">
    <form ng-submit="$ctrl.search()">
    <div class="input-search-big">
      <i class="fa fa-fw fa-search"></i>
      <input class="search" ng-model="$ctrl.searchText" placeholder="Search for Datasets..." />
    </div>
    </form>
    </div>

    <div>&nbsp;</div>
    <div class="section">
      <div class="container container-fluid">
        <div class="category">
        <h2>Labour Market Information Facts & Figures</h2>
        <p class="fancy"><span><i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i></span></p>
        </div>
        <div class="row big-cat fact-group">

          <div class="col-sm-4 fact-item" ng-repeat="group in $ctrl.infographics" ng-init="items = $ctrl.infographicItems(group.infographics)">
            <asg-image data-id="info{{ group.id }}" data-options="$ctrl.infographicOptions" data-items="items">
                <asg-modal></asg-modal>
            </asg-image>
            <h5 class="fact-item-title"><strong>{{ group.name }}</strong></h5>
          </div>

        </div>
      </div>
    </div>
    <div class="section">
      <div class="container container-fluid">
        <div class="category">
        <h2>Dataset Trend</h2>
        <p class="fancy"><span><i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i></span></p>
        </div>
        <div class="row big-cat">
          <div class="col-sm-6">
            <iframe width="100%" height="400" src="https://live.amcharts.com/cyMjE/embed/" frameborder="0"></iframe>
          </div>
          <div class="col-sm-6">
            <iframe width="100%" height="400" src="https://live.amcharts.com/kY2Nj/embed/" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </div>
    
    
    <div class="section">
      <div class="container container-fluid">
        <div class="category">
        <h2>Browse Datasets by Group</h2>
        <p class="fancy"><span><i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube">
        </i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i></span></p>
        </div>
        <div class="row big-cat">
          <div class="col-sm-2 col-sm-offset-2">
            <a href="#/search?group=Student"><img src="${require('../../../../images/studentGroup.jpg')}" alt=""/></a>
          </div>
          <div class="col-sm-2">
            <a href="#/search?group=Trainee"><img src="${require('../../../../images/traineeGroup.jpg')}" alt=""/></a>
          </div>
          <div class="col-sm-2">
            <a href="#/search?group=Union"><img src="${require('../../../../images/UnionGroup.jpg')}" alt=""/></a>
          </div>
          <div class="col-sm-2">
            <a href="#/search?group=Vacancy%20%26%20Jobseeker"><img src=${require("../../../../images/vacancyGroup.jpg")} alt=""/></a>
          </div>
        </div>
        <div class="row big-cat">
          <div class="col-sm-2 col-sm-offset-3">
            <a href="#/search?group=Education%2FTraining%20Institution"><img src="${require('../../../../images/eduNtrainingGroup.jpg')}" alt=""/></a>
          </div>
          <div class="col-sm-2">
            <a href="#/search?group=Employee"><img src="${require('../../../../images/employeeGroup.jpg')}" alt=""/></a>
          </div>
          <div class="col-sm-2">
            <a href="#/search?group=Employer"><img src="${require('../../../../images/employerGroup.jpg')}" alt=""/></a>
          </div>
        </div>
      </div>
    </div>








    <div class="section bg-light-grey">
      <div class="container container-fluid">
        <div class="category">
        <h2>Browse Datasets by Ministry</h2>
        <p class="fancy"><span><i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i></span></p>
        </div>
        <div class="row flex f-center f-wrap">
          <div class="col-md-3 padding-1" ng-repeat="org in $ctrl.ministries|orderBy: 'display_name'">
            <a class="org_tab" style="color: #FFF" ng-href="#/search?ministry={{$ctrl.encodeURI(org.name)}}" ng-class="$ctrl.bgColors[$index]">
              <!--img ng-src="/storage/{{org.logo}}" alt=""/-->
              <span style="color:#FFF">{{org.display_name}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section bg-light-grey">
      <div class="container container-fluid">
        <div class="category">
        <h2>Browse Datasets by Agency</h2>
        <p class="fancy"><span><i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i>&nbsp;<i class="fa fa-cube"></i></span></p>
        </div>
        <div class="row flex f-center f-wrap">
          <div class="col-md-3 padding-1" ng-repeat="org in $ctrl.agencies|orderBy: 'display_name'">
            <a class="org_tab" style="background-color:	#3e6990;" ng-href="#/search?agency={{$ctrl.encodeURI(org.name)}}">
              <!--img ng-src="/storage/{{org.logo}}" alt=""/-->
              <span class="text-center" style="color:#FFF">{{org.display_name}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    `;
}

export class HomeController {
  public static $inject: Array<string> = ["$location","$http","$q", "$anchorScroll", "$uibModal"];
  public category: Array<Object>;
  public searchText;
  public organisations: Array<any>;
  public ministries: Array<any>;
  public agencies: Array<any>;
  public infographics: Array<any>;
  public items = [{
      'id': '2',
      'small': require('../../../../images/2-01-s.jpg'),
      'original': require('../../../../images/2-01.jpg')
    },
    {
      'id': '3',
      'small': require('../../../../images/3-01-s.jpg'),
      'original': require('../../../../images/3-01.jpg')
    },
    {
      'id': '4',
      'small': require('../../../../images/4-01-s.jpg'),
      'original': require('../../../../images/4-01.jpg')
    },
    {
      'id': '5',
      'small': require('../../../../images/5-01-s.jpg'),
      'original': require('../../../../images/5-01.jpg')
    },
    {
      'id': '6',
      'small': require('../../../../images/6-01-s.jpg'),
      'original': require('../../../../images/6-01.jpg')
    },
    {
      'id': '7',
      'small': require('../../../../images/7-01-s.jpg'),
      'original': require('../../../../images/7-01.jpg')
    },
    {
      'id': '8',
      'small': require('../../../../images/8-01-s.jpg'),
      'original': require('../../../../images/8-01.jpg')
    },
    {
      'id': '9',
      'small': require('../../../../images/9-01-s.jpg'),
      'original': require('../../../../images/9-01.jpg')
    }
  ];
  public bgColors = [
    'bg-color-red',
    'bg-color-green',
    'bg-color-purple',
    'bg-color-yellow',
    'bg-color-turquoise',
    'bg-color-yellow'
  ]

  constructor(private $location: ng.ILocationService, private $http:ng.IHttpService, private $q: ng.IQService, private $anchorScroll:ng.IAnchorScrollService, private $uibModal: ng.ui.bootstrap.IModalService) {
    $http.get(`${BASE}/ministry`).then((d:any) => {
      this.ministries = d.data;
    })
    $http.get(`${BASE}/agency`).then((d:any) => {
      this.agencies = d.data;
    })
    $http.get(`https://www.ilmia.gov.my/mobile/api/infographicgroup`).then((d:any) => {
      this.infographics = d.data.data;
    })
  }
  public $onInit() {
    this.$anchorScroll();
  }
  public encodeURI(url) {
    return encodeURIComponent(url);
  }
  public search() {
    this.$location.url("/search").search({q: JSON.stringify({q: this.searchText})});
  }
  public open(path) {
    this.$uibModal.open({
      animation: true,
      template: '<img src="' + path + '" width="100%" alt=""/>',
      size: 'lg'
    });
  }

  public infographicItems(items) {
    let images = items.map(item => item.image_full_path);
    return images;
  }

  public infographicOptions = {
    loadingImage: "preload.svg",
    modal: {
        transition: 'rotateLR',
        size: 'contain',
        header: {
          enabled: true,
          buttons: ['playstop', 'index', 'prev', 'next', 'pin', 'fullscreen', 'close']
        },
        click: {
          close: false
        }
    },
    image: {
      height: 370,
      transition: 'fadeInOut'
    }
  };
}
